<script>
  import { Steps, Faq, DriverForm, Button } from '$client';
  import App from './App.svelte';
  export let data;
  $: page = data.rabotaPage;
</script>

<section id="main">
  <section class="container">
    <div>
      <h1 class="h1">{@html page.header}</h1>
      <p>{page.description}</p>
      {#if page.button[0]}
        <Button action={page.button[0].href ?? page.button[0].modal} title={page.button[0].header} />
      {/if}
    </div>
  </section>
  <Steps data={page.steps} />
  <DriverForm data={page.form.data.attributes} />
  <App data={page.app} />
  <Faq data={page.faq.data.attributes} />
</section>

<style lang="scss">
  #main {
    display: flex;
    flex-direction: column;
    gap: 80px;
    margin-block: 50px;

    @media only screen and (max-width: 767.98px) {
      gap: 50px;
      margin-block: 30px;
    }

    section {
      div {
        position: relative;
        display: flex;
        flex-direction: column;
        gap: 30px;
        align-items: flex-start;
        justify-content: center;
        padding-block: 100px;

        @media only screen and (max-width: 991.98px) {
          padding-block: 50px;
        }

        @media only screen and (max-width: 767.98px) {
          padding-block: 20px;
        }

        @media only screen and (max-width: 575.98px) {
          align-items: center;
        }

        &::before {
          position: absolute;
          right: 0;
          width: calc(60% + 50px);
          height: 100%;
          background-image: url('https://admin.uberi.pro/uploads/Driver_40143403d2.webp');
          background-repeat: no-repeat;
          background-size: 840px 580px;
          border-radius: 15px;
          content: '';
          clip-path: polygon(37% 0, 100% 0, 100% 100%, 0 100%);

          @media only screen and (max-width: 1200px) {
            background-size: 650px 100%;
          }

          @media only screen and (max-width: 991.98px) {
            width: calc(50% + 50px);
            background-size: 450px 100%;
            clip-path: polygon(17% 0, 100% 0, 100% 100%, 0 100%);
          }

          @media only screen and (max-width: 767.98px) {
            display: none;
          }
        }

        h1 {
          max-width: 50%;
          color: rgb(44 51 60 / 100%);
          font-weight: 800;
          font-family:
            Vela Sans,
            sans-serif;

          @media only screen and (max-width: 767.98px) {
            max-width: 100%;
          }
        }

        p {
          color: rgb(44 51 60 / 100%);
          font-size: 18px;

          @media only screen and (max-width: 575.98px) {
            text-align: center;
          }

          font-family: Roboto, sans-serif;
        }

        :global(a),
        :global(button) {
          margin-top: 30px;
        }
      }
    }
  }
</style>
